import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormGroup, Label } from 'reactstrap';

import { dataContractApi } from '../../../helpers/api/dataContractApi';
import { CableTypeText } from '../../../helpers/enums/cableTypeEnum';
import RequiredStarLabel from '../../common/requiredStarLabel';
import EntitySelect from '../../entitySelect/EntitySelect';
import FormGroupNote from '../FormGroupNote';

export default function CableTypeSelect({ isDisabled, isRequired = false }) {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <FormGroup>
      <Label htmlFor="cableType">
        {t('Cable Type')} {isRequired && <RequiredStarLabel />}
      </Label>
      <Controller
        name="cableType"
        control={control}
        render={({ field }) => (
          <EntitySelect
            name="cableType"
            displayName={t('Cable Type')}
            fieldValue={field.value}
            onChange={field.onChange}
            placeholder="No Cable Type"
            fetchDataFunction={() => {
              return dataContractApi.getDataContractsByContractType(
                'cable-types'
              );
            }}
            isFetchDataEnum
            enumToText={CableTypeText}
            isDisabled={isDisabled}
            isClearable={false}
          />
        )}
      />
      {errors.cableType && (
        <FormGroupNote type="warning">{errors.cableType.message}</FormGroupNote>
      )}
    </FormGroup>
  );
}
